<div class="calendar-container">
  <div class="calendar-header">
    <div class="header-top">
      <div class="header-left">
        <h1>Vacation Calendar</h1>
      </div>
      <div class="header-right">
        <div class="user-filter" *ngIf="users?.length">
          <div class="custom-select" (click)="toggleUserDropdown()">
            <div class="selected-option">
              <span class="user-dot" [style.background-color]="selectedUser ? getUserColor(selectedUser.uid) : '#666'"></span>
              <span>{{ selectedUser?.firstName || 'All Users' }}</span>
              <i class="fas fa-chevron-down select-arrow"></i>
            </div>
            <div class="select-dropdown" *ngIf="showUserDropdown">
              <div class="dropdown-option all-option" (click)="selectUser(null)">
                <span class="user-dot" style="background-color: #666"></span>
                <span>All Users</span>
              </div>
              <div class="dropdown-option" *ngFor="let user of users" (click)="selectUser(user)">
                <span class="user-dot" [style.background-color]="getUserColor(user.uid)"></span>
                <span>{{ user.firstName }} {{ user.lastName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="month-navigation">
      <button class="btn-icon" (click)="previousMonth()">
        <i class="fas fa-chevron-left"></i>
      </button>
      <h2>{{ currentDate | date:'MMMM yyyy' }}</h2>
      <button class="btn-icon" (click)="nextMonth()">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>

  <div class="calendar-weekdays">
    <div class="weekday">Sun</div>
    <div class="weekday">Mon</div>
    <div class="weekday">Tue</div>
    <div class="weekday">Wed</div>
    <div class="weekday">Thu</div>
    <div class="weekday">Fri</div>
    <div class="weekday">Sat</div>
  </div>

  <div class="calendar-grid">
    <div *ngFor="let day of calendarDays$ | async" 
         class="calendar-day" 
         [class.other-month]="!day.isCurrentMonth"
         [class.today]="day.isToday">
      <div class="day-header">
        <span class="day-number" [class.today-number]="day.isToday">
          {{ day.date | date:'d' }}
        </span>
      </div>
      <div class="day-content">
        <div *ngFor="let span of day.timeOffSpans" 
             class="time-off-span"
             [class.span-start]="span.isStart"
             [class.span-middle]="span.isMiddle"
             [class.span-end]="span.isEnd"
             [class.approved]="span.request.status === 'approved'">
          <div class="time-off-content">
            <span class="user-dot" [style.background-color]="getUserColor(span.request.userId)"></span>
            <span class="time-off-info">
              {{ getUserName(span.request.userId) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 